import PropTypes from 'prop-types'
import ChannelCarousels from './carousels'
import ChannelBranch from '../branch-grid/branch-grid'
import channelProps from 'shared/prop-types/channel'

const { arrayOf, bool } = PropTypes

const ChannelChildren = ({ channelChildren, isBranch, autoPlay }) => (
    <div>
        {isBranch ? (
            <ChannelBranch channelChildren={channelChildren} autoPlay={autoPlay} />
        ) : (
            <ChannelCarousels channels={channelChildren} autoPlay={autoPlay} />
        )}
    </div>
)

ChannelChildren.propTypes = {
    channelChildren: arrayOf(channelProps),
    autoPlay: bool,
    isBranch: bool,
    isLoading: bool,
}

export default ChannelChildren
